var LIFECYCLE_WILL_ENTER = "ionViewWillEnter",
    LIFECYCLE_DID_ENTER = "ionViewDidEnter",
    LIFECYCLE_WILL_LEAVE = "ionViewWillLeave",
    LIFECYCLE_DID_LEAVE = "ionViewDidLeave",
    LIFECYCLE_WILL_UNLOAD = "ionViewWillUnload";
export { LIFECYCLE_WILL_LEAVE as a, LIFECYCLE_WILL_ENTER as b, LIFECYCLE_DID_ENTER as c, LIFECYCLE_DID_LEAVE as d, LIFECYCLE_WILL_UNLOAD as e };